const form7 = {
  formId7: "new-user-form7",
  formField7: {
    endow: {
      name: "endow",
      label: "Ưu đãi cùng/ khác địa bàn với nơi có trụ sở chính:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn ưu đãi cùng/ khác địa bàn với nơi có trụ sở chính",
    },
    departmentLevel: {
      name: "departmentLevel",
      label: "Cơ quan thuế cấp Cục:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn cơ quan thuế cấp Cục",
    },
    subordinateToTheDepartment: {
      name: "subordinateToTheDepartment",
      label: "Cơ quan thuế cấp chi Cục:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn cơ quan thuế cấp chi Cục",
    },
    city: {
      name: "city",
      label: "[09C] Tỉnh/ thành phố:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn tỉnh/ thành phố",
    },
    district: {
      name: "district",
      label: "[09B] Quận/ huyện:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn quận/ huyện",
    },
    commune: {
      name: "commune",
      label: "[09C] Xã/ phường:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn xã/ phường",
    },

  },
};

export default form7;
